module.exports = __webpack_public_path__ + "img/FF_Info_Game_5.9b76dd1d.png";